module.exports = __webpack_public_path__ + "static/media/ALIANZA BRA-13.d832b518.png";